<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { checkWx } from "@/wx/check";
// import wxcheck from "@/wx/check";
export default {
  created() {
    checkWx();
  },
  mounted() {
    // console.log(wxcheck);
    // wxcheck.check().then(() => {
    //   window["wx"].invoke("showWatermark", {}, (res) => {
    //     console.log("开启水印", res);
    //   });
    // });
  },
};
</script>
<style lang="scss">
@import "@/styles";

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
